import axios from "axios";
export default {
  state: {
    faqs: [],
    faqsEs: [],
    selectedFaq: {},
    viewFaq: false,
    faqCategory: [],
    faqCategoryEs: [],
    addFaq: false,

    maps: [],
    selectedMap: {},
    viewMap: false,
    floors: [],
  },
  getters: {
    getFaqs: (state) => state.faqs,
    getFaqsEs: (state) => state.faqsEs,
    getSelectedFaq: (state) => state.selectedFaq,
    getViewFaq: (state) => state.viewFaq,
    getFaqCategory: (state) => state.faqCategory,
    getFaqCategoryEs: (state) => state.faqCategoryEs,
    getAddFaq: (state) => state.addFaq,

    getMaps: (state) => state.maps,
    getViewMap: (state) => state.viewMap,
    getSelectedMap: (state) => state.selectedMap,
  },
  mutations: {
    setFaqs(state, faq) {
      state.faqs.push(faq);
    },
    setFaqsEs(state, faq) {
      state.faqsEs.push(faq);
    },
    setSelectedFaq(state, faq) {
      state.selectedFaq = faq;
    },
    setViewFaq(state, status) {
      state.viewFaq = status;
    },
    setFaqCategory(state, category) {
      state.faqCategory.push(category);
    },
    setFaqCategoryEs(state, category) {
      state.faqCategoryEs.push(category);
    },
    setAddFaq(state, status) {
      state.addFaq = status;
    },

    setMaps(state, map) {
      state.maps.push(map);
    },
    setViewMap(state, status) {
      state.viewMap = status;
    },
    setSelectedMap(state, map) {
      state.selectedMap = map;
    },
  },
  actions: {
    pullFaqs({ commit, getters }) {
      if (getters.getFaqs.length === 0) {
        let config = {
          method: "get",
          url: "https://cms.mdcourts.arsconnect.com/faqs?_limit=-1",
          maxBodyLength: Infinity,
          headers: {
            "Content-Type": "application/json",
          },
        };
        axios
          .request(config)
          .then((response) => {
            response.data.forEach((faq) => {
              commit("setFaqs", faq);
            });
          })
          .catch((error) => {
            console.log("Error Fetching Faqs", error);
          });
      }
    },
    pullFaqsEs({ commit, getters }) {
      if (getters.getFaqs.length === 0) {
        let config = {
          method: "get",
          url: "https://cms.mdcourts.arsconnect.com/faqs?_limit=-1&_locale=es-US",
          maxBodyLength: Infinity,
          headers: {
            "Content-Type": "application/json",
          },
        };
        axios
          .request(config)
          .then((response) => {
            response.data.forEach((faq) => {
              commit("setFaqsEs", faq);
            });
          })
          .catch((error) => {
            console.log("Error Fetching Faqs", error);
          });
      }
    },
    pullFaqCategories({ commit, getters }) {
      if (getters.getFaqs.length === 0) {
        let config = {
          method: "get",
          url: "https://cms.mdcourts.arsconnect.com/faq-categories?_limit=-1",
          maxBodyLength: Infinity,
          headers: {
            "Content-Type": "application/json",
          },
        };
        axios
          .request(config)
          .then((response) => {
            response.data.forEach((category) => {
              commit("setFaqCategory", category);
            });
          })
          .catch((error) => {
            console.log(error.message);
          });
      }
    },
    pullFaqCategoriesEs({ commit, getters }) {
      if (getters.getFaqs.length === 0) {
        let config = {
          method: "get",
          url: "https://cms.mdcourts.arsconnect.com/faq-categories?_limit=-1&_locale=es-US",
          maxBodyLength: Infinity,
          headers: {
            "Content-Type": "application/json",
          },
        };
        axios
          .request(config)
          .then((response) => {
            response.data.forEach((category) => {
              commit("setFaqCategoryEs", category);
            });
          })
          .catch((error) => {
            console.log(error.message);
          });
      }
    },
    pullMaps({ commit, getters }) {
      if (getters.getMaps.length === 0) {
        let config = {
          method: "get",
          url: "https://cms.mdcourts.arsconnect.com/maps?_limit=-1",
          maxBodyLength: Infinity,
          headers: {
            "Content-Type": "application/json",
          },
        };
        axios
          .request(config)
          .then((response) => {
            response.data.forEach((map) => {
              commit("setMaps", map);
            });
          })
          .catch((error) => {
            console.log(error.message);
          });
      }
    },
  },
};
